import React from 'react'
import parse from 'html-react-parser'
import {
  hasCoachAccolades,
  hasCoachBio,
} from '../../../utils/hasCoachAdditionalInfo'

/**
 * Expandable skills / accolades / bio panel for a coach card.
 */
function CoachExpandedInfo({ coach, translateSkill, labels }) {
  const accolades = coach.coachAccolades
  const skills = coach.coachSkills || []

  return (
    <div className="p-4">
      {skills.length > 0 && (
        <div className="mb-4 grid grid-cols-3 gap-y-1">
          {skills.map((skill, index) => {
            const slot = index + 1
            const firstInRow = index % 3 === 0
            let lastInRow = slot % 3 === 0
            if (slot === skills.length) lastInRow = true

            return (
              <div
                key={`${skill}-${index}`}
                className={`relative z-10 ${
                  skills.length % 3 > 0 && slot === skills.length
                    ? `col-span-${3 - (slot % 3) + 1}`
                    : ''
                } border border-intoo-green-medium-800 bg-intoo-green-medium-800 p-2 text-center text-sm text-white ${
                  firstInRow ? 'rounded-l-md' : ''
                } ${lastInRow ? 'rounded-r-md' : ''}`}
              >
                <span className="font-medium text-white">
                  {translateSkill ? translateSkill(skill) : skill}
                </span>
                {!lastInRow && (
                  <div className="absolute -top-px right-1 z-50 flex h-[calc(100%+2px)] w-1 -skew-x-12 justify-center bg-intoo-green-medium-50" />
                )}
              </div>
            )
          })}
        </div>
      )}

      {hasCoachAccolades(accolades) && (
        <div className="mb-4 grid grid-cols-1 gap-1 @md:grid-cols-4">
          {accolades.yearsExperience > 0 && (
            <div className="rounded-md border border-cod-gray-100 bg-white/75 p-2">
              <span className="text-sm font-medium text-intoo-green-medium-800">
                {accolades.yearsExperience} {labels.yearsExperience}
              </span>
            </div>
          )}
          {accolades.numClientsSupported > 0 && (
            <div className="rounded-md border border-cod-gray-100 bg-white/75 p-2">
              <span className="text-sm font-medium text-intoo-green-medium-800">
                {labels.supportedClients(accolades.numClientsSupported)}
              </span>
            </div>
          )}
          {accolades.numRatings > 0 && accolades.satisfactionRating > 0 && (
            <div className="rounded-md border border-cod-gray-100 bg-white/75 p-2">
              <span className="text-sm font-medium text-intoo-green-medium-800">
                {labels.satisfactionRating(accolades.satisfactionRating)}
              </span>
            </div>
          )}
        </div>
      )}

      {hasCoachBio(coach.coachBio) && (
        <div className="mt-4">
          <h4 className="mb-2 text-left font-medium text-intoo-green-medium-800">
            {labels.aboutCoach(coach.displayName)}
          </h4>
          <div className="max-h-48 overflow-auto text-left text-sm">
            {parse(coach.coachBio)}
          </div>
        </div>
      )}
    </div>
  )
}

export default CoachExpandedInfo
